export { RecoveryPassForm } from './recovery-pass-form';
